import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ReportBuilderService } from '../report-builder.service';
import { NotificationsService } from 'angular2-notifications';
import { PhotoCommentUpdateModel } from '../report-builder-models';

@Component({
    selector: 'measurement-point-photos',
    templateUrl: './measurement-point-photos.component.html',
    styleUrls: ['./measurement-point-photos.component.scss']
})
export class MeasurementPointPhotosComponent implements OnInit, OnChanges {

    @Input() image_id = 0;
    @Input() image_data = '';
    @Input() image_title = '';
    @Input() image_comment = '';
    @Input() figure_number = '';
    @Input() isRecommendationPhoto = false;
    @Input() isHidden = false;
    @Input() isLarge = false;

    @Output() removePhoto: EventEmitter<number> = new EventEmitter();
    @Output() togglePhoto   = new EventEmitter();
    @Output() toggleResize: EventEmitter<boolean> = new EventEmitter();
    mandatoryImageComment = '';

    @Output() EditPhotoComment = new EventEmitter();

    displayToggleButton = false;

    constructor(private _rbService: ReportBuilderService,
    private _notify: NotificationsService) { }

    ngOnInit() {
    }
    ngOnChanges(): void {
      if (this.image_comment) {
          this.mandatoryImageComment =  this.image_comment;
      }
  }


    deleteImage() {
        if (this.image_id !== 0) {
            this.removePhoto.emit(this.image_id);
        }
    }

    toggleShowOrHide() {
        if (this.image_id !== 0) {
            this.isHidden = !(this.isHidden);
            this.togglePhoto.emit({imageId: this.image_id, isHidden: this.isHidden});
        }
    }

    toggleImageSizeLarge() {
        this.isLarge = true;
        this.toggleResize.emit(this.isLarge);
    }

    toggleImageSizeSmall() {
        this.isLarge = false;
        this.toggleResize.emit(this.isLarge);
    }

    onMouseOver() {
        this.displayToggleButton = true;
    }

    onMouseOut() {
        this.displayToggleButton = false;
    }


    valueChanged(newVar: string){
        this.image_comment = newVar;
    }

    saveComment(newValue: string) {
        this.image_comment = newValue;
        if (this.image_id !== 0) {
            this.EditPhotoComment.emit({id: this.image_id, newComment: newValue});
        }
    }
}
